module.exports = __webpack_public_path__ + "img/dark-icon-logo.6437d251.svg";